import { Component, OnInit } from '@angular/core';
import { SwitchLanguageService } from "../../common/services/switch-language.service";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
